export default __webpack_public_path__ + "static/media/ic_gmx_arbitrum.59f04e87.svg";